/* eslint-disable */
import { create } from "zustand";

const useProductMappingStore = create((set) => ({
    parentTabList: [],
    childTabList: [],
    selectedParentTab: "",
    selectedChildTab: {},
    dropDownLists: {},
    selectedDropDownValue: {},
    productWiseMappingData: [],
    mappingDataValues: {},
    tableData: { headers: [], rows: [] },
    resetKey: 0,

    setParentTabList: (tabList) => set({ parentTabList: tabList }),
    setSelectedParentTab: (tab) => set({ selectedParentTab: tab }),
    setChildTabList: (tabList) => set({ childTabList: tabList }),
    setSelectedChildTab: (tab) => set({ selectedChildTab: tab }),
    setDropDownLists: (dropDownLists) => set({ dropDownLists: dropDownLists }),
    setSelectedDropDownValue: (value) => set({ selectedDropDownValue: value }),
    setProductWiseMappingData: (data) => set({ productWiseMappingData: data }),
    setMappingDataValues: (data) => set({ mappingDataValues: data }),
    setTableData: (data) => set({ tableData: data }),
    setResetKey: (keyOrFn) => set((state) => ({
        resetKey: typeof keyOrFn === 'function' ? keyOrFn(state.resetKey) : keyOrFn
    })),

    setInitialData: (data) => set(data),
    updateTabs: (parent, childList, child, dropdowns, initialDropDown = {}) => set({
        selectedParentTab: parent,
        childTabList: childList,
        selectedChildTab: child,
        dropDownLists: dropdowns,
        selectedDropDownValue: initialDropDown,
        tableData: { headers: [], rows: [] }
    }),
    resetTabs: () => set({
        selectedParentTab: "",
        selectedChildTab: {},
        childTabList: [],
        dropDownLists: {},
        selectedDropDownValue: {},
        tableData: { headers: [], rows: [] }
    }),
}))

export default useProductMappingStore;